<template>
	<div class="createinvoice">
		<invoice ref="invoice" @invoicecallback="invoicecallback"></invoice>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';	
import invoice from '@/components/invoice/invoice.vue';
export default {
	components: {
		invoice
	},
	props: {
	},
	data() {
		return {
			type:'',
			handletype:'out',
			divclass:'createinvoice'
		}
	},
	mounted() {
		var param='';
		if(this.$route.query!=undefined){
			if(this.$route.query.param!=undefined)
				param=this.$route.query.param;
		}
		//debugger
		if(param!='')
			this.init(param);
	},
	methods: {
		init(param) {
			var that=this;
			this.$nextTick(function() {
				that.$refs.invoice.init({
					param:param
				});
			});
		},
		//发票开完之后的调用
		invoicecallback(e){
			if(e.result){
				var that=this;
				if(e.pkval!=''){
					this.$tool.loading('正在生成电子发票', this.divclass);
					this.$tool.GetWlcode(that,e.invoicetype+'发票').then(res=>{
						if(res.state=='1'){
							if(res.list.length>0){
								that.showpdf(res.list[0].wlcode,e);
							}
							else
								this.$tool.loadingclose();
						}
						else
							this.$tool.loadingclose();
					});
				}
			}
		},
		showpdf(wlcode,e){
			var that=this;
			var paraminfo={
				pkval:e.pkval,
				priority:2,
				wlcode:wlcode
			}
			this.$apipost.get.GetOrderMd({paraminfo:paraminfo}).then(res => {
				if(res.state=='1')
				{	
					this.$tool.loadingclose();
					if(res.labelurl!=undefined)
						window.location.href=unescape(res.labelurl);
				}
				else if(res.state=='2')
					that.recreateinvoice(e,5);
				else
				{
					this.$tool.loadingclose();
					this.$tool.message(res.message, 0);
				}
			});
		},
		//如果没有生成，就重调5次
		recreateinvoice(e,times){
			if(times>0){
				var that=this;
				times=parseInt(times)-1;
				setTimeout(function(){
					that.recreateinvoice(e,times);
				},5000);
			}
		}
	},
}
</script>

<style>
</style>
